import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import React, { useEffect } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
// @ts-ignore
import styles from './form.module.scss';

interface CustomDropDownInputProps extends FieldRenderProps {
  label: any,
  id: any,
  dropDownValues: any,
  readOnly: any,
  defaultItem: any,
  // eslint-disable-next-line react/require-default-props
  className?: any,
  // eslint-disable-next-line react/require-default-props
  popupClassName?: any
}

export const CustomDropDownInput = (props: CustomDropDownInputProps) => {
  const dropDownRef = React.useRef(null);

  useEffect(() => {
    if (dropDownRef && dropDownRef.current && dropDownRef.current.element) {
      const inputs = dropDownRef.current.element.querySelectorAll('.k-input');
      inputs.forEach((item) => {
        item.setAttribute('role', 'option');
        // this should probably be the value of the seletion or a general 'Select whatever' if not populated.
        item.setAttribute('title', 'option value');
      });
    }
  }, [props]);

  return (
    <FieldWrapper className={props.className}>
      <DropDownList
        id={props.id}
        label={props.label}
        data={props.dropDownValues || []}
        textField="name"
        dataItemKey="id"
        value={props.dropDownValues?.length > 0 ? (props.value || '') : 1}
        onChange={props.onChange}
        disabled={props.readOnly}
        defaultItem={props.defaultItem}
        className={`${props.readOnly ? styles.disabledDropdown : null} ${props.dropDownValues?.length ? '' : styles.noOptions}`}
        ref={dropDownRef}
        popupSettings={{
          className: props.popupClassName
        }}
      />
    </FieldWrapper>
  );
};

interface CustomDropDownInputUnwrappedProps extends FieldRenderProps {
  label: any,
  id: any,
  dropDownValues: any,
  readOnly: any,
  defaultItem: any,
}

export const CustomDropDownInputUnwrapped = (props: CustomDropDownInputUnwrappedProps) => {
  const dropDownRef = React.useRef(null);

  useEffect(() => {
    if (dropDownRef && dropDownRef.current && dropDownRef.current.element) {
      const inputs = dropDownRef.current.element.querySelectorAll('.k-input');
      inputs.forEach((item) => {
        item.setAttribute('role', 'option');
        // this should probably be the value of the seletion or a general 'Select whatever' if not populated.
        item.setAttribute('title', 'option value');
      });
    }
  }, [props]);

  return (
    <DropDownList
      id={props.id}
      label={props.label}
      data={props.dropDownValues || []}
      textField="name"
      dataItemKey="id"
      value={props.value || ''}
      onChange={props.onChange}
      disabled={props.readOnly}
      defaultItem={props.defaultItem}
      ref={dropDownRef}
    />
  );
};
